var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmarkUnfilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1688 16.5049L4.10728 19.6152C3.62332 19.8508 3.02708 19.684 2.76028 19.2385V19.2385C2.68309 19.1004 2.64144 18.9474 2.63867 18.7916V5.00988C2.63867 2.38145 4.55629 1.33008 7.31578 1.33008H13.7982C16.4736 1.33008 18.4754 2.31136 18.4754 4.83465V18.7916C18.4754 19.0403 18.3699 19.2787 18.1822 19.4545C17.9945 19.6303 17.7399 19.7291 17.4745 19.7291C17.3051 19.7266 17.1387 19.6876 16.988 19.6152L10.8891 16.5049C10.6643 16.3912 10.3936 16.3912 10.1688 16.5049Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkUnfilled);
export default __webpack_public_path__ + "static/media/bookmark-unfilled.86111680e3691e4c86c1a8d9be7faeeb.svg";
export { ForwardRef as ReactComponent };